module.exports = __webpack_public_path__ + "img/map_1791444926220_39300.c82936d4.jpg";